import * as React from 'react';
export const IcHandSoap = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15 8V7a1 1 0 00-1-1h-1V4h.51a2 2 0 01.64.1l2.53.9c.106.014.214.014.32 0a1 1 0 001.05-1.068 1 1 0 00-.68-.882l-2.54-.84A3.93 3.93 0 0013.51 2H9a1 1 0 000 2h2v2h-1a1 1 0 00-1 1v1a3 3 0 00-3 3v8a3 3 0 003 3h6a3 3 0 003-3v-8a3 3 0 00-3-3z'
      fill='currentColor'
    />
  </svg>
);
